import { useEffect, useMemo } from 'react';

import { ColorsParameterMap } from '@theme/types/colors.types.tsx';
import { applyPaletteToDom, mergePaletteWithRemote } from '@theme/utils/themeUtils.tsx';
import { useAppSelector } from '@store/store.tsx';
// import { logInfo } from '@tools/LogsHandler.tsx';

export const useApplySiteColors = () => {
  const siteColors = useAppSelector((state) => state.settings.site?.site_colors);

  // logInfo('[DEBUG] useApplySiteColors - siteColors from Redux:', JSON.stringify(siteColors, null, 2));

  const palette = useMemo<ColorsParameterMap>(() => {
    const merged = mergePaletteWithRemote({}, siteColors ?? null);
    // logInfo('[DEBUG] useApplySiteColors - merged palette:', JSON.stringify(merged, null, 2));
    return merged;
  }, [siteColors]);

  useEffect(() => {
    // logInfo('[DEBUG] useApplySiteColors - applying palette to DOM. Keys:', Object.keys(palette).join(', '));
    applyPaletteToDom(palette);
  }, [palette]);
};
